module.exports = __webpack_public_path__ + "media/npc_dota_hero_faceless_void.2eb2b645.webm";